/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_CREATE
 */
export const createColdStandardConnectionBody = zod.object({
  "apiKey": zod.string()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const getColdStandardConnectionParams = zod.object({
  "id": zod.string().uuid()
})

export const getColdStandardConnectionResponse = zod.object({
  "apiKey": zod.string()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const updateColdStandardConnectionParams = zod.object({
  "id": zod.string().uuid()
})

export const updateColdStandardConnectionBody = zod.object({
  "apiKey": zod.string()
})

export const updateColdStandardConnectionResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

